import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useTabStore } from "@/stores/tabStore";
import { useMenuChildrenList, useMenuList } from "../menu/useMenu";

export function useAutoTab() {
  const location = useLocation();
  const { addTab } = useTabStore();
  const { data: menuChildrenList } = useMenuChildrenList();
  const { data: menuList } = useMenuList();

  // DB에서 가져온 메뉴 데이터를 path-to-name 매핑 객체로 변환
  // 하위 메뉴 + 단독 메뉴(parent_id 없고 path 있는 메뉴) 포함
  const pathTitleMap = useMemo(() => {
    const map: Record<string, string> = {};

    // 하위 메뉴 추가
    if (menuChildrenList) {
      menuChildrenList.forEach(menu => {
        if (menu.path) {
          map[menu.path] = menu.name;
        }
      });
    }

    // 단독 메뉴 추가 (parent 없고 path 있는 메뉴)
    if (menuList) {
      menuList.forEach(menu => {
        if (menu.path && !menu.parent) {
          map[menu.path] = menu.name;
        }
      });
    }

    return map;
  }, [menuChildrenList, menuList]);

  useEffect(() => {
    const currentPath = location.pathname;
    const title = pathTitleMap[currentPath];

    if (title) {
      addTab({ title, path: currentPath });
    }
  }, [location.pathname, addTab, pathTitleMap]);
}
